import Vue from 'vue';
Vue.directive('auth', {
  inserted: function (el, binding) { // 在被绑定的元素插入到dom中时
    const list = window.localStorage.getItem('Auths') ? JSON.parse(window.localStorage.getItem('Auths')) : []; // 用户拥有的权限列表
    let allAuths = list.map(v => { return v.resourceId })
    // console.log(list, binding.value, hasAuth(binding.value, allAuths), 'listtttttttttttttt');
    if (binding.value && !hasAuth(binding.value, allAuths)) { // binding.value 可以获得绑定指令时传入的参数
      el.style = 'display:none'; // 修改元素的可见状态
    }
    function hasAuth (needAuths, allAuths) { // 判断用户是否拥有权限的function
      // console.log(typeof allAuths.indexOf(needAuths), 'ttttttttttttttttt')
      if (!allAuths || !allAuths.length) { return false }
      // implement
      if (allAuths.indexOf(needAuths) === -1) {
        return false;
      } else {
        return true
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/auth.js